/**
 * Sentry init helper para admin web.
 *
 * Se llama en `main.tsx` antes de ReactDOM.createRoot. Si no hay
 * `VITE_SENTRY_DSN` configurado, Sentry queda deshabilitado y la app
 * sigue funcionando normal.
 *
 * v2 puede agregar:
 * - replayIntegration para grabar sesiones de usuario al reproducir bugs.
 * - Source maps upload via @sentry/vite-plugin (requiere auth token).
 * - User context (linkear errores a session.user.id post-login).
 */

import * as Sentry from '@sentry/react'

const DSN = import.meta.env.VITE_SENTRY_DSN as string | undefined
const APP_ENV =
  (import.meta.env.VITE_APP_ENV as string | undefined) ??
  (import.meta.env.DEV ? 'development' : 'production')

let initialized = false

export function initSentry(): void {
  if (initialized) return
  if (!DSN) {
    if (import.meta.env.DEV) {
      console.log('[sentry] VITE_SENTRY_DSN not set — skipping init')
    }
    return
  }

  Sentry.init({
    dsn: DSN,
    environment: APP_ENV,
    enabled: true,
    debug: import.meta.env.DEV,
    tracesSampleRate: APP_ENV === 'production' ? 0.2 : 1.0,
    sampleRate: 1.0,
  })

  initialized = true
}

export { Sentry }
